import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BlockUI } from "primereact/blockui";
import { Dialog } from "primereact/dialog";
import { Password as PRPassword } from "primereact/password";
import { ProgressSpinner } from "primereact/progressspinner";
import swal from "sweetalert";
import Logo from "../../icons/NuevoLogoPiSeun.png";
import { PASSWORD_MIN_LENGTH, PASSWORD_MIN_LENGTH_ERROR, passwordCumpleLongitudMinima } from "../../servicios/passwordPolicy";
import { useStoreRegistro } from "./useRegistroStore";
import "./registro.css";

const terms = [
  ["1. Licencia de uso", "El software se otorga bajo licencia limitada, no exclusiva e intransferible, destinada exclusivamente al uso comercial interno del usuario. Se prohíbe su distribución, sublicencia o modificación sin autorización."],
  ["2. Propiedad intelectual", "Todos los derechos sobre el software, incluyendo su diseño, funcionalidad, código fuente y documentación, son propiedad exclusiva de Twins Informatica SRL."],
  ["3. Uso autorizado", "El usuario se compromete a utilizar el software conforme a la legislación aplicable, evitando prácticas como ingeniería inversa, descompilación o alteraciones no autorizadas."],
  ["4. Confidencialidad", "El usuario acuerda mantener la confidencialidad de las credenciales, documentación técnica y cualquier información sensible relacionada con el software."],
  ["5. Soporte y actualizaciones", "Twins Informatica SRL podrá ofrecer soporte técnico y actualizaciones durante la vigencia de la licencia, sin obligación de continuidad permanente."],
  ["6. Limitación de responsabilidad", "Twins Informatica SRL no será responsable por daños indirectos, pérdida de datos o interrupciones comerciales derivadas del uso o mal funcionamiento del software o por causas ajenas a Twins Informatica SRL."],
  ["7. Terminación", "El incumplimiento de estos términos podrá derivar en la revocación de la licencia sin reembolso. Al finalizar, el usuario deberá desinstalar el software y eliminar cualquier copia."],
  ["8. Jurisdicción", "Para cualquier disputa legal, ambas partes se someten a la jurisdicción de los tribunales de San Isidro, Provincia de Buenos Aires, Argentina, conforme a la legislación vigente."],
];

const Registro = () => {
  const Mail = useStoreRegistro((state) => state.Mail);
  const PasswordValue = useStoreRegistro((state) => state.Password);
  const ConfirmPassword = useStoreRegistro((state) => state.ConfirmPassword);
  const Procesando = useStoreRegistro((state) => state.Procesando);
  const RegistroOk = useStoreRegistro((state) => state.RegistroOk);
  const Descripcion = useStoreRegistro((state) => state.Descripcion);
  const Nombre = useStoreRegistro((state) => state.Nombre);
  const Apellido = useStoreRegistro((state) => state.Apellido);
  const Cuit = useStoreRegistro((state) => state.Cuit);
  const Rubro = useStoreRegistro((state) => state.Rubro);
  const navigate = useNavigate();
  const [mostrarTyC, setMostrarTyC] = useState(false);
  const [aceptoTyC, setAceptoTyC] = useState(false);

  useEffect(() => {
    useStoreRegistro.getState().limpiar();
  }, []);

  useEffect(() => {
    if (RegistroOk) {
      useStoreRegistro.setState({ RegistroOk: false });
      navigate("/login");
    }
  }, [RegistroOk, navigate]);

  const actualizar = (campo) => (event) => {
    useStoreRegistro.setState({ [campo]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!passwordCumpleLongitudMinima(PasswordValue)) {
      swal("Contraseña inválida", PASSWORD_MIN_LENGTH_ERROR, "error");
      return;
    }
    if (PasswordValue !== ConfirmPassword) {
      swal("Las contraseñas no coinciden", "Por favor, verificalas e intentalo nuevamente.", "error");
      return;
    }
    useStoreRegistro.getState().insertOperador();
  };

  return (
    <main className="registro-page">
      <section className="registro-card" aria-labelledby="registro-title">
        <header className="registro-header">
          <img src={Logo} alt="PiSeun" className="registro-logo" />
          <div>
            <p className="registro-eyebrow">Creá tu cuenta</p>
            <h1 id="registro-title">Empezá con PiSeun</h1>
            <p>Completá tus datos para configurar tu empresa.</p>
          </div>
        </header>

        <BlockUI blocked={Procesando} className="registro-block" template={<ProgressSpinner style={{ width: "32px", height: "32px" }} strokeWidth="6" animationDuration=".8s" />}>
          <form className="registro-form" onSubmit={handleSubmit}>
            <fieldset className="registro-section">
              <legend>Datos de la empresa</legend>
              <div className="registro-grid">
                <TextField id="empresa" label="Nombre de la empresa" value={Descripcion} onChange={actualizar("Descripcion")} placeholder="Ej. Almacén Central" autoComplete="organization" />
                <TextField id="rubro" label="Rubro" value={Rubro} onChange={actualizar("Rubro")} placeholder="Ej. Comercio minorista" />
                <TextField id="cuit" label="CUIT (opcional)" value={Cuit} onChange={actualizar("Cuit")} placeholder="Ej. 30-12345678-9" inputMode="numeric" required={false} wide />
              </div>
            </fieldset>

            <fieldset className="registro-section">
              <legend>Datos de acceso</legend>
              <div className="registro-grid">
                <TextField id="nombre" label="Nombre" value={Nombre} onChange={actualizar("Nombre")} placeholder="Tu nombre" autoComplete="given-name" />
                <TextField id="apellido" label="Apellido" value={Apellido} onChange={actualizar("Apellido")} placeholder="Tu apellido" autoComplete="family-name" />
                <TextField id="email" label="Correo electrónico" value={Mail} onChange={actualizar("Mail")} placeholder="nombre@empresa.com" type="email" autoComplete="email" wide />
                <PasswordField id="password" label="Contraseña" value={PasswordValue} onChange={actualizar("Password")} placeholder={`Mínimo ${PASSWORD_MIN_LENGTH} caracteres`} />
                <PasswordField id="confirm-password" label="Repetir contraseña" value={ConfirmPassword} onChange={actualizar("ConfirmPassword")} placeholder="Ingresala nuevamente" />
              </div>
            </fieldset>

            <label className="registro-terms" htmlFor="tyc">
              <input id="tyc" type="checkbox" checked={aceptoTyC} onChange={(event) => setAceptoTyC(event.target.checked)} required />
              <span>Acepto los <button type="button" onClick={() => setMostrarTyC(true)}>Términos y Condiciones</button></span>
            </label>

            <button className="registro-submit" type="submit" disabled={Procesando}>
              {Procesando ? "Creando cuenta…" : "Crear cuenta"}
            </button>
            <p className="registro-login-link">¿Ya tenés una cuenta? <Link to="/login">Iniciar sesión</Link></p>
          </form>
        </BlockUI>
      </section>

      <Dialog
        header="Términos y Condiciones"
        visible={mostrarTyC}
        onHide={() => setMostrarTyC(false)}
        className="registro-dialog"
        style={{ width: "min(92vw, 720px)" }}
        draggable={false}
        dismissableMask
        footer={<DialogActions onClose={() => setMostrarTyC(false)} onAccept={() => { setAceptoTyC(true); setMostrarTyC(false); }} />}
      >
        <div className="registro-terms-copy">
          <p>Al aceptar, reconocés que leíste y comprendiste los términos establecidos por Twins Informatica SRL.</p>
          {terms.map(([title, copy]) => <section key={title}><h2>{title}</h2><p>{copy}</p></section>)}
        </div>
      </Dialog>
    </main>
  );
};

const TextField = ({ id, label, value, onChange, placeholder, type = "text", autoComplete = "off", inputMode, required = true, wide = false }) => (
  <div className={`registro-field ${wide ? "registro-field-wide" : ""}`}>
    <label htmlFor={id}>{label}</label>
    <input id={id} name={id} type={type} value={value} onChange={onChange} placeholder={placeholder} autoComplete={autoComplete} inputMode={inputMode} required={required} />
  </div>
);

const PasswordField = ({ id, label, value, onChange, placeholder }) => (
  <div className="registro-field">
    <label htmlFor={id}>{label}</label>
    <PRPassword inputId={id} name={id} value={value} onChange={onChange} toggleMask feedback={false} placeholder={placeholder} autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} required />
  </div>
);

const DialogActions = ({ onClose, onAccept }) => (
  <div className="registro-dialog-actions">
    <button type="button" className="registro-dialog-secondary" onClick={onClose}>Cerrar</button>
    <button type="button" className="registro-dialog-primary" onClick={onAccept}>Aceptar términos</button>
  </div>
);

export default Registro;
